import { Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImageViewerComponent>,
    private sanitizer: DomSanitizer
  ) {
   }

  ngOnInit() {
  }

  updateImgIndex(nextIndex) {
    if (nextIndex>=0 && nextIndex<this.data.imageList.length) {
      console.log(nextIndex);
      this.data.currentIndex = nextIndex;
    }
  }

  downloadImage() {
    let link=document.createElement('a');
    link.href=this.data.imageList[this.data.currentIndex].blobUrl;
    link.download = this.data.imageList[this.data.currentIndex].fileName; // give image name
    link.click();
      
  }

  getSafeUrl(blobUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(blobUrl);
}

  close() {
    this.dialogRef.close();
  }
}
